import type { BarbadosGameState, SelectActionArgs, BarbadosActionType } from '../../types';
import type { Ctx } from 'boardgame.io';

export interface ValidationResult {
  success: boolean;
  error?: string;
  message?: string;
}

/**
 * アクション選択のバリデーション（Barbados固有）
 * @param G - Barbadosゲーム状態
 * @param ctx - Boardgame.ioコンテキスト
 * @param args - アクション選択引数
 * @returns バリデーション結果
 */
export function validateSelectActionBarbados(
  G: BarbadosGameState,
  _ctx: Ctx,
  args: SelectActionArgs
): ValidationResult {
  // Barbados専用アクションチェック
  const validActions: BarbadosActionType[] = [
    'ENGINEER',
    'LOCOMOTIVE',
    'URBANIZATION',
    'PRODUCTION'
  ];

  if (!validActions.includes(args.action as BarbadosActionType)) {
    return {
      success: false,
      error: 'INVALID_ACTION_BARBADOS',
      message: `Action ${args.action} is not available in Barbados solo play. Valid actions: ${validActions.join(', ')}`
    };
  }

  // アクションマーカーチェック
  if (G.actionMarkers && G.actionMarkers[args.action as BarbadosActionType] === true) {
    // 使用可能なアクションをリストアップ
    const availableActions = validActions.filter(
      action => G.actionMarkers![action] === false
    );

    return {
      success: false,
      error: 'ACTION_MARKER_USED',
      message: `Action ${args.action} has already been used (marker placed). Available actions: ${availableActions.join(', ')}`
    };
  }

  // Issue #23: Locomotive選択時の機関車レベル上限チェックを削除
  // Barbadosでは4つのアクションを使い切る必要があるため、
  // 機関車レベルが最大でもLOCOMOTIVEアクションは選択可能
  // （ただしレベルは上がらない - selectActionsBarbados.ts で処理）

  return { success: true };
}
